import React from 'react';
import SelectInput from "./SelectInput";

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const QuantitySelectInput = (props) => {

    const getQuantityTypeOptions = () => {
        let options = [];

        if (props.includeNoneOption) {
            options.push({
                label: 'None',
                value: 0,
            })
        }

        options.push({
            label: props.singleLabel,
            value: 1,
        })

        options.push({
            label: 'Multiple',
            value: 2,
        });

        options.push({
            label: 'Unlimited',
            value: -1,
        });

        return options;
    }
    const getValueForSelect = () => {
        switch (parseInt(props.value)) {
            case -1:
            case 0:
            case 1:
                return parseInt(props.value);
            default:
                return 2;
        }
    }

    const handleChange = (event) => {
        let value = parseInt(event.target.value);

        // Don't let them enter zero in the text box, that is not valid
        if (!props.includeNoneOption && value === 0) {
            value = 1;
        }

        props.onChange(props.name, value);
    }

    return (
        <div className="grid-x grid-margin-x">
            <div className="cell small-6">
                <SelectInput
                    options={getQuantityTypeOptions()}
                    value={getValueForSelect()}
                    onChange={handleChange}
                />
            </div>
            <div className="cell small-6">
                { (getValueForSelect() === 2) && (
                    <input
                        type="number"
                        value={props.value}
                        onChange={handleChange}
                    />
                )}
            </div>
        </div>
    )
}

QuantitySelectInput.defaultProps = {
    includeNoneOption: false,
    singleLabel: 'Single'
}

export default QuantitySelectInput;
